export const setAnimationStage = ( stage ) => {
    return{
        type: 'CHANGE_ANIMATION_STAGE',
        stage
    };
};

export const showChooseABacteriaSection = () => {
    return{
        type: 'CHANGE_CHOOSE_A_BACTERIA_STATUS',
        status: true
    };
};

export const hideChooseABacteriaSection = () => {
    return{
        type: 'CHANGE_CHOOSE_A_BACTERIA_STATUS',
        status: false
    };
};

export const setActiveBacteria = ( bacteria ) => {
    return{
        type: 'SET_ACTIVE_BACTERIA',
        bacteria
    };
};

export const changeExitingStatus = ( status ) => {
    return{
        type: 'CHANGE_EXITING_STATUS',
        status
    }
};

export const setActiveFeature = ( featureKey ) => {
    return{
        type: 'SET_ACTIVE_FEATURE',
        featureKey
    }
};

export const resetActiveFeature = () => {
    return{
        type: 'SET_ACTIVE_FEATURE',
        featureKey: null
    }
};

export const setFeatureIndicator = ( indicatorRef, title ) => {
    return {
        type: 'SET_FEATURE_INDICATOR',
        indicatorRef,
        title
    }
};

export const setObjectPosition = ( x, y ) => {
    return {
        type: 'SET_OBJECT_INDICATOR_POSITION',
        objectPos: { x, y }
    }
};

export const resetObjectPosition = () => {
  return {
      type: 'REMOVE_OBJECT_INDICATOR_POSITION'
  };
};

export const resetFeatureMap = () => {
    return {
        type: 'RESET_MAP_POSITION'
    }
};

export const setHoverPos = ( xPos, yPos ) => {
    return {
        type: 'SET_HOVER_POS',
        xPos,
        yPos
    };
};

export const setActivePetri = ( petriCombo ) => {
    return {
      type: "SET_ACTIVE_PETRI",
      petriCombo
    };
};

export const setReturning = () => {
    return {
        type: "SET_RETURNING"
    }
};


// WEBPACK FOOTER //
// ./src/actions/index.js